module.exports = __webpack_public_path__ + "static/media/transform-icon.3c44e79e.svg";